import React from 'react';

function ActiveDeliveries({ deliveries, onViewRoute }) {
  if (deliveries.length === 0) {
    return (
      <div className="active-deliveries">
        <div className="section-header">
          <h2>Active Deliveries</h2>
        </div>
        
        <div className="empty-state">
          <div className="empty-icon">📦</div>
          <h3>No active deliveries</h3>
          <p>Select deliveries from the Available tab to start earning</p>
        </div>
      </div>
    );
  }

  const totalEarnings = deliveries.reduce((sum, d) => sum + d.payment, 0);
  const totalDistance = deliveries.reduce((sum, d) => sum + d.distance, 0);

  return (
    <div className="active-deliveries">
      <div className="section-header">
        <h2>Active Deliveries</h2>
        <button className="btn-route" onClick={onViewRoute}>
          🗺️ View Route
        </button>
      </div>

      <div className="active-summary">
        <div className="summary-card">
          <div className="summary-icon">📦</div>
          <div className="summary-content">
            <div className="summary-value">{deliveries.length}</div>
            <div className="summary-label">Packages</div>
          </div>
        </div>
        <div className="summary-card">
          <div className="summary-icon">💰</div>
          <div className="summary-content">
            <div className="summary-value">€{totalEarnings.toFixed(2)}</div>
            <div className="summary-label">Total Earnings</div>
          </div>
        </div>
        <div className="summary-card">
          <div className="summary-icon">🛣️</div>
          <div className="summary-content">
            <div className="summary-value">{totalDistance.toFixed(1)} km</div>
            <div className="summary-label">Total Distance</div>
          </div>
        </div>
      </div>

      <div className="deliveries-list">
        {deliveries.map((delivery, index) => (
          <div key={delivery.id} className="active-delivery-card">
            <div className="delivery-number">#{index + 1}</div>
            
            <div className="delivery-info">
              <div className="delivery-title">
                <span className="order-id">{delivery.orderId}</span>
                <span className="package-code">{delivery.packageCode}</span>
              </div>
              
              <div className="delivery-customer">
                <span className="customer-name">👤 {delivery.customerName}</span>
                <a href={`tel:${delivery.customerPhone}`} className="customer-phone">
                  📞 {delivery.customerPhone}
                </a>
              </div>

              <div className="delivery-address">
                <span className="address-icon">📍</span>
                <span className="address-text">{delivery.deliveryAddress}</span>
              </div>

              <div className="delivery-details">
                <span className="detail-item">
                  <strong>Distance:</strong> {delivery.distance} km
                </span>
                <span className="detail-item">
                  <strong>Payment:</strong> €{delivery.payment.toFixed(2)}
                </span>
                <span className="detail-item">
                  <strong>Code:</strong> {delivery.deliveryCode}
                </span>
              </div>
            </div>

            <div className="delivery-status">
              <span className="status-badge status-in-transit">
                🚚 In Transit
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ActiveDeliveries;
